import React, { useCallback } from 'react';
import { useRouter } from 'expo-router';
import { defineMessages, useIntl } from 'react-intl';
import { StyleSheet, View } from 'react-native';

import { LoadingPlaceholder, theme } from '@sg/garnish';

import { SavedPaymentMethod } from '../SavedPaymentMethod';

export const AdditionalPaymentMethods = () => {
  const router = useRouter();

  const hasEnrolledToFlex = false; // to be replaced by graphql query.
  const isLoadingAccounts = false; // to be replaced by graphql query

  const { formatMessage } = useIntl();

  const flexText = hasEnrolledToFlex
    ? formatMessage(messages.flexLinked)
    : formatMessage(messages.flexUnlinked);

  // ─── Callbacks ───────────────────────────────────────────────────────

  const handleLinkFlexAccount = useCallback(() => {
    router.navigate('/hsa-fsa');
  }, [router]);

  if (isLoadingAccounts) {
    return <LoadingPlaceholder rows={3} rowHeight={32} palette="cream" />;
  }

  return (
    <View style={styles.container}>
      <SavedPaymentMethod
        icon="IconFlex"
        style={styles.paymentMethod}
        description={flexText}
        a11yLabel={formatMessage(messages.flexAccessibilityLabel)}
        isSuccess={hasEnrolledToFlex}
        onPress={handleLinkFlexAccount}
      />
    </View>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  flexAccessibilityLabel: {
    defaultMessage: 'Link your Flex account',
    description: 'Additional Payment Methods | Flex Accessibility Label',
  },
  flexUnlinked: {
    defaultMessage: 'Link your Flex account - pay using your HSA / FSA',
    description: 'Additional Payment Methods | Flex Unlinked',
  },
  flexLinked: {
    defaultMessage: 'Flex account has been linked',
    description: 'Additional Payment Methods | Flex Linked',
  },
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: theme.spacing['6'],
    backgroundColor: theme.colors.OPACITY.WHITE.DARKEST,
    borderRadius: theme.radius.large,
    borderColor: theme.colors.GRAY,
    borderWidth: 1,
  },
  paymentMethod: {
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.LIGHT,
  },
});
